export default __webpack_public_path__ + "static/media/top.e8ccd266.png";